import { loadStripe } from '@stripe/stripe-js';

/**
 * Lazily-loaded Stripe.js singleton (one instance per app load), cached after
 * the first call. Stripe.js is ~80KB and the vendor flags pages that load it
 * unused — call `getStripe` only inside the payment-method update flow. The
 * publishable key comes from `/payment-session` and is passed in by the caller.
 *
 * See https://pieinsurance.atlassian.net/wiki/spaces/PD/pages/5206048770
 */
let stripePromise: ReturnType<typeof loadStripe> | undefined;

export const getStripe = (publishableKey: string) => {
  stripePromise ??= loadStripe(publishableKey).catch((error) => {
    // Don't cache the rejection — a one-time Stripe.js load failure would
    // otherwise dead-end every later dialog open until a full page reload. Reset
    // the singleton so the next open retries the load.
    stripePromise = undefined;
    throw error;
  });
  return stripePromise;
};
